var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pro-wrapper"},[_c('span',[_c('i',{staticClass:"fa fa-lg",class:[_vm.iconClass],attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"info"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',[_c('small',[_vm._v(_vm._s(_vm.text))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48d1a4da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Pro.vue
// module id = null
// module chunks = 